import * as React from 'react'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import { HereResult } from '@user/store/services/hereGeoCoder'
import Button from '@mui/material/Button'
import List from '@mui/material/List'

type Props = {
  recentSearches: HereResult[]
  clearRecentSearches: () => void
  onClick: (result: HereResult) => void
}

export function RecentSearches(props: Props): JSX.Element | null {
  const { recentSearches, clearRecentSearches, onClick } = props
  if (recentSearches.length === 0) {
    return null
  }

  return (
    <Stack spacing={1} sx={{ width: '100%' }} alignItems={'flex-start'}>
      <Typography variant="caption">Recent searches</Typography>

      <List dense sx={{ py: 0, width: '100%', mt: '0px !important' }}>
        {recentSearches.map((location, idx) => (
          <ListItemButton
            key={`${location.id}-${idx}`}
            sx={{ px: 0 }}
            onClick={() => onClick(location)}
          >
            <ListItemIcon sx={{ minWidth: 28 }}>
              <AccessTimeIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText
              primary={location.address.label}
              primaryTypographyProps={{ variant: 'body2' }}
            />
          </ListItemButton>
        ))}
      </List>
      <Button
        variant="text"
        aria-label="Clear"
        onClick={clearRecentSearches}
        sx={{
          color: '#1565C0',
          minWidth: 0,
          width: 'fit-content',
          mt: '0px !important',
        }}
        size="small"
      >
        Clear
      </Button>
    </Stack>
  )
}

export default RecentSearches
